export const emailRegex =
  /^\s*[;,]*\s*([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})\s*([;,]\s*([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}))*\s*[;,]?\s*$/;
export const emailMessage = 'Emails must be in the form of abc@mail.ca; xyz@mail.ca';

export const expDateRegex = /^\d{2}\/\d{2}$/;
export const expDateMaessage = 'Expiry must be formatted MM/YY';

export const latitudeRegex = /^-?(90(\.0+)?|([1-8]?\d(\.\d+)?))$/;
export const latitudeValidationMessage =
  'Invalid latitude. Please enter a value between -90 and 90 (e.g., 45.0 or -23.56).';

export const longitudeRegex = /^-?(180(\.0+)?|(1[0-7]\d(\.\d+)?|([1-9]?\d(\.\d+)?)))$/;
export const longitudeValidationMessage =
  'Invalid longitude. Please enter a value between -180 and 180 (e.g., 120.45 or -75.0).';

export const nameRegex = /^[a-zA-Z\s]+$/;
export const nameValidationMessage = 'Name can only contain letters and spaces due to travelport restrictions';
